<div class="modal-content">
  <div class="modal-header justify-content-center">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
          <i class="nc-icon nc-simple-remove"></i>
      </button>
      <h4 class="title title-up">{{ nR_BPM_BEM_PATRIMONIAL }}</h4>
  </div>
  <div class="modal-body">
      <div *ngIf="!loading">
          <div id="accordion" role="tablist" aria-multiselectable="true" class="card-collapse">

              <div class="card card-plain">
                  <div class="card-header" role="tab" id="headingOne">
                      <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true"
                          aria-controls="collapseOne">
                          Dados básicos
                      </span>
                  </div>
                  <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                      <div class="card-body">
                          <div class="row">
                            <table class="table">
                                <thead>
                                  <tr>
                                    <th scope="col">Nr. movimentação</th>
                                    <th scope="col">Data da movimentação</th>
                                    <th scope="col">Tipo da movimentação</th>
                                    <th scope="col">Autor da movimentação</th>
                                    <th scope="col">Descrição da evidencia</th>
                                    <th scope="col">Nome do arquivo</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let mov of movimentacao">
                                    <td>
                                      {{ mov.cD_BPM_MOVIMENTACAO_PATRIMONIAL }}
                                    </td>
                                    <td>
                                      {{ mov.dT_DATA_MOVIMENTACAO_PATRIMONIAL | date:'dd/MM/yyyy'}}
                                    </td>
                                    <td>
                                      {{ mov.dS_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL }}
                                    </td>
                                    <td>
                                      {{ mov.dS_NM_AUTOR }}
                                    </td>
                                    <td>
                                      {{ mov.dS_BPM_TEXTO_EVIDENCIA }}
                                    </td>
                                    <td  type="button" class="btn-link" 
                                    (click)="upload_abrir(mov.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL,mov.cD_BPM_ARQUIVO_PATRIMONIAL)">
                                    {{mov.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL}}
                                    </td>
                                    
                                  </tr>
                                  <br/>
                                  <img> 
                                </tbody>
                              </table>

                              <!-- <div class="row align-items-center">
                                  <hr>
                              </div>
                              
                              <div class="row ">
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="ds_nm_origem">Nome de origem</label>
                                          <p id="ds_nm_origem">{{movimentacao.dS_NM_ORIGEM}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="desc">Nome de destino</label>
                                          <p>{{movimentacao.dS_NM_DESTINO}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="matricula">Nome do Gestor</label>
                                          <p>{{movimentacao.dS_NM_GESTOR}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="location">Tipo de Movimentação</label>
                                          <p>{{movimentacao.dS_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="sala">Descrição do bem</label>
                                          <p>{{movimentacao.dS_BPM_DESCRICAO_BEM}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="tipoDeBem">Sala</label>
                                          <p>{{movimentacao.dS_BPM_SALA_POSTERIOR}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="depreciacao">Data da movimentação</label>
                                          <p>{{movimentacao.dT_DATA_MOVIMENTACAO_PATRIMONIAL | date:'dd/MM/yyyy'}}</p>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mx-auto">
                                      <div class="form-group">
                                          <label for="depreciacao">Descrição da evidencia</label>
                                          <p>{{movimentacao.dS_BPM_TEXTO_EVIDENCIA}}</p>
                                      </div>
                                  </div>
                                </div>
                                  <div id="accordion">
                                      <div class="card card-plain">
                                        <div class="card-header mx-auto" id="headingOne">
                                          <h5 class="mb-2">
                                            <button 
                                            class="btn btn-outline-dark btn-link p-3"
                                            (click)="isCollapsedFile = !isCollapsedFile">
                                            Ver arquivo
                                            </button>
                                          </h5>
                                        </div>
                                        <div id="collapseOne"
                                        *ngIf="!isCollapsedFile" 
                                        class="fade-in">
                                        <div class="col-md-12">
                                          <div class="card-body">
                                            <table class="table">
                                              <thead>
                                                <tr>
                                                  <th>Nome do arquivo</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td  type="button" class="text-truncate btn-link" 
                                                  (click)="upload_abrir(movimentacao.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL)">
                                                  {{movimentacao.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL}}
                                                  
                                                  </td>
                                                </tr>
                                                <br/>
                                                <img> 
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        </div>
                                      </div>
                                    </div>
                                -->
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row ">
              <div class="col-md-12 text-center " *ngIf="loading ">
                  <img src="../../../../assets/img/loading.png" class="loading" id="loadingImage" height="50 "
                      width="50 " />
              </div>
          </div>
      </div>
  </div>

  <div *ngIf="!loading" class="modal-footer">
      <div class="mx-auto text-center">
          <button type="button" class="btn btn-danger btn-link mw-100 text-decoration-none" (click)="activeModal.close()">
              Fechar
          </button>
      </div>
  </div>